module.exports = __webpack_public_path__ + "img/logo.f6b506f2.png";